module.exports = __webpack_public_path__ + "img/10.c38cd8a3.jpg";